import React, { useContext } from "react";
import PropTypes from "prop-types";
import Overlay from "../Overlay";
import ContentLoader from "react-content-loader";
import { langComponent } from "../../constants";
import AppContext from "../../AppContext";

import { ReactComponent as CloseSvg } from "../../assets/projectView/close.svg";

const Loading = ({ onClose }) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.common);

  return (
    <Overlay
      onClose={onClose}
      style={{
        alignItems: "flex-start",
      }}
    >
      <div className="project-view">
        <div className="project-view-close" onClick={onClose}>
          <CloseSvg />
          {Translation("Close")}
        </div>
        <div className="project-view-content">
          <div className="project-view-content-ctas">
            <div
              className={`project-view-content-ctas-action project-view-content-ctas-action--avatar`}
            >
              <ContentLoader width={"100%"} height={"100%"}>
                <circle cx="50%" cy="50%" r="50%" />
              </ContentLoader>
            </div>
          </div>
          <div className="project-view-content-container">
            <div className="project-view-content-container-banner">
              <ContentLoader width={"100%"} height={600}>
                <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
              </ContentLoader>
            </div>
            <div className="project-view-content-container-info">
              <div className="project-view-content-container-info-categories">
                <ContentLoader width={100} height={27}>
                  <rect
                    x="0"
                    y="0"
                    rx="13"
                    ry="13"
                    width="100%"
                    height="100%"
                  />
                </ContentLoader>
                <ContentLoader width={100} height={27}>
                  <rect
                    x="0"
                    y="0"
                    rx="13"
                    ry="13"
                    width="100%"
                    height="100%"
                  />
                </ContentLoader>
                <ContentLoader width={100} height={27}>
                  <rect
                    x="0"
                    y="0"
                    rx="13"
                    ry="13"
                    width="100%"
                    height="100%"
                  />
                </ContentLoader>
                <ContentLoader width={100} height={27}>
                  <rect
                    x="0"
                    y="0"
                    rx="13"
                    ry="13"
                    width="100%"
                    height="100%"
                  />
                </ContentLoader>
              </div>
              <div className="project-view-content-container-info-desc">
                <div className="project-view-content-container-info-desc__avatar">
                  <ContentLoader width={96} height={96}>
                    <circle cx="48" cy="48" r="48" />
                  </ContentLoader>
                </div>
                <span className="project-view-content-container-info-desc__title">
                  <ContentLoader width={120} height={30}>
                    <rect
                      x="0"
                      y="0"
                      rx="8"
                      ry="8"
                      width="100%"
                      height="100%"
                    />
                  </ContentLoader>
                </span>
                <div className="project-desc-detail__rating">
                  <ContentLoader width={"100%"} height={30}>
                    <circle cx="9" cy="9" r="9" />
                    <circle cx="35" cy="9" r="9" />
                    <circle cx="61" cy="9" r="9" />
                    <circle cx="87" cy="9" r="9" />
                    <circle cx="113" cy="9" r="9" />
                  </ContentLoader>
                </div>
                <span className="project-view-content-container-info-desc__desc">
                  <ContentLoader width={"100%"} height={66}>
                    <rect
                      x="0"
                      y="0"
                      rx="8"
                      ry="8"
                      width="100%"
                      height="100%"
                    />
                  </ContentLoader>
                </span>
              </div>
            </div>
            <div className="project-view-content-container-more">
              <span className="project-view-content-container-more__header">
                <ContentLoader width={200} height={22}>
                  <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
                </ContentLoader>
              </span>
              <ContentLoader width={256} height={256}>
                <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
              </ContentLoader>
            </div>
            <div className="project-view-content-container-more">
              <span className="project-view-content-container-more__header">
                <ContentLoader width={120} height={22}>
                  <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
                </ContentLoader>
              </span>
              <ContentLoader width={256} height={256}>
                <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
              </ContentLoader>
            </div>
          </div>
        </div>
      </div>
    </Overlay>
  );
};

Loading.propTypes = {};

export default Loading;
